import { IButtonProps, TextButton } from 'src/styles/button.style';
import styled, { css } from 'styled-components';
import theme from 'src/theme';
import { PanelHeaderStyle, PanelWrapperStyle } from 'src/styles/panel.style';

type GridProps = {
    cols?: string;
};
type PanelProps = {
    defaultPosition?: string;
    alignItems?: string;
    top?: string;
    left?: string;
    flexType?: string;
    noBorder?: boolean;
};

export type SectionProps = {
    alignTop?: boolean;
    noMargin?: boolean;
    flexWidth?: string;
};

type InputFieldsProps = {
    width?: string;
    gridColWidths?: string;
};

export const PanelWrapper = styled(PanelWrapperStyle) <PanelProps>`
    .highlight-text {
        font-weight: 600;
    }

    box-shadow: ${({ theme }) => theme.colors.shadow.ccc} 0px 2px 6px 2px;
    line-height: 1.2rem;

    ${(props) => props.defaultPosition === 'right' && `max-height: 80vh - 25px; min-height: 250px;`}

    .separator {
        border: 1px solid ${({ theme }) => theme.colors.border.eee};
        height: 1px;
        margin: 20px;
    }

    .textarea-input {
        width: 100% !important;
    }

    textarea {
        border: 1px solid ${({ theme }) => theme.colors.border.ccc};
        border-radius: 4px;
        padding: 5px;
        height: 50px !important;
        width: 100% !important;
    }

    .trade-name-select__menu {
        width: 500px;
        * {
            padding: 2px;
            line-height: 1.25rem;
        }
    }

    .trade-name-select__control {
        height: 24px;
        padding: 0 5px;
        line-height: 1;
        * {
            padding: 0;
            line-height: 1;
        }
    }

    .field-wrapper {
        display: flex;
        justify-content: space-between;
    }

    .adjusted-input input {
        background: bisque;
    }

    .adjusted-value {
        background: bisque;
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 0 5px 0 0;
        height: 25px;
    }

    .input-value-description {
        min-width: 100px;
    }

    label .read-only-input {
        max-width: 300px;
    }

    label .input-value input.number {
        width: 80px;
    }

    label .input-value input.number.small-input {
        width: 55px;
    }

    label .input-value input.number.large-input {
        width: 100px;
    }

    .highlight-panel {
        background: ${({ theme }) => theme.colors.background.panelSection};
        border: 1px solid ${({ theme }) => theme.colors.border.ccc};
        border-radius: 4px;
        padding: 0.5rem;
    }

     .input-small-field {
        display: inline-block;
        margin-left: 5px;
    }

    .input-small {
        width: 75px;
    }

    .input-small {
        display: flex;
        justify-items: flex-end;
        justify-content: flex-end;
        align-content: start;
        width: 82px;
        gap: 5px;
    }

    .error-message {
        color: ${({ theme }) => theme.colors.text.error};
    }
        
    .external-link-icon {
        margin-left: 4px;
        color: ${theme.legacyColors.primaryTextColor};
    }
`;

export const PanelHeader = styled(PanelHeaderStyle)`
    cursor: pointer;

    .header-content {
        padding: 0.75rem;
    }

    .header-actions {
        display: flex;
        align-items: center;
        margin-left: auto;
        flex-shrink: 0;
        gap: 0;
    }

    .minimize-icon {
        height: 35px;
        width: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.85rem;
        opacity: 0.6;
        transition: opacity 0.15s;
        &:hover {
            opacity: 1;
            background: ${({ theme }) => theme.colors.background.odfjellPanel.menuBackground};
        }
    }

    .close-icon {
        height: 35px;
        width: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.95rem;
        &:hover {
            background: ${({ theme }) => theme.colors.background.odfjellPanel.menuBackground};
        }
    }

    .ext-info {
        font-size: 0.8rem;
        font-style: italic;
    }
`;

export const PanelSubHeader = styled.div<PanelProps>`
    font-weight: 600;
    font-size: 1rem;
    margin: 0 0 5px 0;
    color: ${theme.legacyColors.primaryTextColor};

    display: flex;
    align-items: center;
    gap: 5px;
    
    padding: 0 0 5px 0;
    .ext-info {
        font-size: 0.8rem;
        font-style: italic;
    }
    .padding-right {
        padding-right: 48px;
    }
    ${(props) => !props.noBorder && `border-bottom: 2px solid #eee;`}
`;


export const PanelGroupHeader = styled.div`
    font-size: 0.9rem;
    font-weight: 600;
    margin-bottom: 0.25rem;
    border-bottom: 1px solid ${(props) => props.theme.colors.border};
    color: ${(props) => props.theme.colors.primary};
`;

export const PanelSecondaryHeader = styled.div<PanelProps>`
    display: flex;
    gap: 5px;
    margin: 0 0 10px;
    ${(props) => props.alignItems === 'right' && `place-content: end;`}
`;

export const PanelComponentsGridContainer = styled.div<GridProps>`
    display: grid;
    grid-template-columns: ${(props) => props.cols};
    grid-template-rows: 25px 25px;
    gap: 5px;
    align-items: center;
`;

export const PanelContent = styled.div`
    padding: 0;
`;

export const PanelSectionContent = styled.div`
    padding: 0.5rem;
`;

export const DefaultWrapper = styled.div<SectionProps>`
    ${(props) => (!props.noMargin ? `margin: 0.5rem;` : ``)};
    width: 100 %;
`;

export const DefaultPanelWrapper = styled(DefaultWrapper) <SectionProps>`
    ${(props) => (props.flexWidth ? 'flex: 0 0 ' + props.flexWidth : '')};
    ${(props) => (props.flexWidth ? 'max-width: ' + props.flexWidth : '')};
`;

export const DefaultFlexWrapper = styled(DefaultWrapper) <SectionProps>`
    display: flex;
    ${(props) => (props.alignTop ? `align-items: flex-start;` : `align-items:center `)};
`;

export const DefaultFlexEndWrapper = styled(DefaultFlexWrapper)`
    justify-content: flex-end;
`;

export const DefaultFlexStartWrapper = styled(DefaultFlexWrapper)`
    justify-content: flex-start;
`;

export const DefaultFlexStrechedWrapper = styled(DefaultFlexWrapper) <SectionProps>`
    justify-content: space-between;
    grid-gap: 5px;
    width: 100%;

    .left-wrapper {
        flex: 0 0 50%;
        max-width: 50%;
        display: flex;
    }
    .right-wrapper {
        flex: 0 0 50%;
        max-width: 50%;
        display: flex;
        justify-content: flex-end;
    }
`;

export const IntervalWrapper = styled.div`
    display: grid;
    grid-template-columns: 5px 1fr 10px 1fr 15px;
    align-items: center;
    label .input-value-wrapper .input-unit {
        width: auto;
        margin: 0 5px;
    }

    label .input-value-wrapper .read-only-input {
        min-width: 40px;
    }
`;

export const PanelFlexWrapper = styled.div`
    display: flex;
    align-items: top;
    gap: 15px;
    .left-wrapper {
        flex: 1 1 67.55%;
    }
    .right-wrapper {
        flex: 0 0 32.5%;
    }
`;


export const BottomPanelButtonsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background-color: ${(props) => props.theme.colors.backgroundSecondary};
    border-top: 1px solid ${(props) => props.theme.colors.border};

    .left-buttons {
        display: flex;
        gap: 10px;
        flex-grow: 1;
    }

    .right-buttons {
        display: flex;
        gap: 10px;
        justify-content: flex-end;
    }

    .button-bar {
        margin-left: 10px;
    }

    .error-message {
        color: ${(props) => props.theme.colors.error};
        margin-bottom: 10px;
    }

    /* Override the generic SaveButton's height/padding/font-size so it
       matches the neighboring Cancel PanelButton on the same row, without
       touching the shared SaveButton styles used elsewhere in the app. */
    .panel-save-btn {
        height: 34px;
        padding: 0 18px;
        font-size: 0.9rem;
        min-width: 0;
    }
`;


export const RotationDropDownWrapper = styled.div`
    height: 400px;
    position: relative;
    overflow-y: auto;
    li {
        padding: 2px;
        &.selected {
            background-color: ${({ theme }) => theme.colors.background.selected};
        }
        cursor: pointer;
    }
    .port-call-name {
        &.selected {
            background-color: ${({ theme }) => theme.colors.background.selected};
        }
        font-weight: 600;
    }
    .berth-call-list {
        padding-left: 10px;
    }
`;

export const ElementWrapper = styled.div`
    position: relative;
    select {
        width: 250px;
    }

    label .input-value-description {
        margin: 0 5px 0 0;
        display: inline-block;
        margin: 0 5px 0 0;
    }
    label {
        padding: 2px 0;
        align-items: center;
    }
    label .input-value.textarea-input {
        width: 100%;

        textarea {
            width: 100%;
            border: 1px solid ${({ theme }) => theme.colors.border.ccc};
            border-radius: 4px;
            padding: 0.25rem;
            background: ${({ theme }) => theme.colors.background.fafafa};
        }
    }
`;

export const ElementRangeStyle = styled.div<InputFieldsProps>`
    display: flex;
    gap: 5px;
    align-items: center;
    width: ${(props) => (props.width ? props.width : 'auto')};

    label .input-value.read-only-input {
        min-width: auto;
    }

    label .input-unit {
        margin-left: 5px;
        width: auto;
    }

    .range-separator {
        font-weight: 600;
        margin: 0 3px 0 2px;
    }
`;

export const InputFieldsWrapper = styled.div<InputFieldsProps>`
    display: grid;
    grid-template-columns: ${(props) => props.gridColWidths};
    gap: 0 2px;
    align-items: center;
`;

export const OptionsElementWrapper = styled(DefaultWrapper) <SectionProps>`
    display: flex;
    gap: 0 10px;
    margin: 0px 0px 5px;
    justify-content: flex-start;
    align-items: center;
    
     .input-value-wrapper {
        display: flex;
        justify-content: flex-start;
        flex: auto;
    }
`;

export const PanelButtonsWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 10px;
    .left-buttons {
        display: flex;
        gap: 10px;
        flex-grow: 1;
    }
    .right-buttons {
        display: flex;
        gap: 10px;
        justify-content: flex-end;
    }
`;

export const PanelButton = styled(TextButton) <IButtonProps>`
    height: 34px;
    padding: 0 18px;
    font-size: 0.9rem;
    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.5;
        `}
    box-shadow: ${({ theme }) => theme.colors.shadow.button} 0px 1px 10px -2px;
    .icon {
        margin-left: 5px;}
`;

export const HighlightPanel = styled.div`
    background: ${({ theme }) => theme.colors.background.panelSection};
    border: 1px solid ${({ theme }) => theme.colors.border.ccc};
    border-radius: 4px;
    padding: 0.5rem;
`;

export const Curtain = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 12;
`;

export const AdjustedStowageList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    overflow-x: auto;
    width: 650px;
    li {
        padding: 5px;
        margin: 5px 5px 0 0;
        border: 1px solid ${({ theme }) => theme.colors.border.button};
        border-radius: 4px;
        box-shadow: ${({ theme }) => theme.colors.shadow.button} 0px 2px 12px 5px;
        label {
            font-weight: 600;
            display: inline-block;
            width: 90px;
        }
    }
`;

export const ColorList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(4, 70px);
    gap: 5px;
    li {
        cursor: pointer;
        padding: 10px;
        margin: 5px 2px 0 0;
        border-radius: 4px;
        border: 2px solid transparent;
        height: 40px;
        &.selected {
            border: 3px solid ${theme.legacyColors.selectedColor};
        }
    }
`;

export const BlockTankContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const CargoDetailsTable = styled.table`
    table-layout: fixed;
    width: 100%;
    overflow: hidden;

    td:first-child {
        white-space: nowrap;
        display: block;
        width: 275px;
    }
`;

export const TankDetailsTable = styled.table`
    td:first-child {
        white-space: nowrap;
        display: block;
        width: 275px;
    }
`;

export const HighlightText = styled.div`
    font-size: 1rem;
    display: flex;
    justify-content: right;
    font-weight: 600;
`;

export const SectionHeaderButton = styled.button<IButtonProps>`
    border: 1px solid ${({ theme }) => theme.colors.border.odfjellSection};
    background: ${({ theme }) => theme.colors.background.odfjellSection};
    color: ${({ theme }) => theme.colors.text.odfjellSection};
    vertical-align: middle;
    outline: 0;
    font-size: 0.7rem;
    font-weight: 500;
`;

export const NamesList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 8px;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.text.secondary};
`;

export const MoreItemsLink = styled.span`
    color: ${({ theme }) => theme.colors.text.link};
    cursor: pointer;
`;
